<div class="hidden xl:block fixed top-0 left-0 right-0 z-40">
  <div
    class="h-[100px] flex flex-row justify-between items-center py-4 px-20 border border-neutral-border bg-neutral-50"
  >
    <img [src]="getLogoPath()" [alt]="t('nav.images.logo')" class="w-[221px] h-[33px]" />

    <div class="flex flex-row gap-[26px] items-center">
      @if (currentUserRole() === UserRole.admin) {
        @let isAdminHome = adminRoute === "home";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminHome,
            'bg-transparent': !isAdminHome,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/admin/home'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminHome,
              'text-neutral-600': !isAdminHome,
            }"
            class="pi pi-home"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminHome,
              'text-neutral-600': !isAdminHome,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.home") }}
          </p>
        </button>

        @let isAdminTemplates = adminRoute === "templates";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminTemplates,
            'bg-transparent': !isAdminTemplates,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/admin/templates'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminTemplates,
              'text-neutral-600': !isAdminTemplates,
            }"
            class="pi pi-file"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminTemplates,
              'text-neutral-600': !isAdminTemplates,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.templates") }}
          </p>
        </button>

        @let isAdminInstitutions = adminRoute === "institutions";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminInstitutions,
            'bg-transparent': !isAdminInstitutions,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/admin/institutions'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminInstitutions,
              'text-neutral-600': !isAdminInstitutions,
            }"
            class="pi pi-building"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminInstitutions,
              'text-neutral-600': !isAdminInstitutions,
            }"
            class="text-xs font-semibold whitespace-nowrap"
          >
            {{ t("nav.institutions") }}
          </p>
        </button>

        @let isAdminUsers = adminRoute === "users";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminUsers,
            'bg-transparent': !isAdminUsers,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/admin/users'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminUsers,
              'text-neutral-600': !isAdminUsers,
            }"
            class="pi pi-user"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminUsers,
              'text-neutral-600': !isAdminUsers,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.users") }}
          </p>
        </button>

        @let isAdminProjects = adminRoute === "projects";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminProjects,
            'bg-transparent': !isAdminProjects,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="['/' + routeUser + '/projects']"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminProjects,
              'text-neutral-600': !isAdminProjects,
            }"
            class="pi pi-briefcase"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminProjects,
              'text-neutral-600': !isAdminProjects,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.projects") }}
          </p>
        </button>

        @let isAdminReports = adminRoute === "report";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminReports,
            'bg-transparent': !isAdminReports,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/admin/report'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminReports,
              'text-neutral-600': !isAdminReports,
            }"
            class="pi pi-chart-bar"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminReports,
              'text-neutral-600': !isAdminReports,
            }"
            class="text-xs font-semibold whitespace-nowrap"
          >
            {{ t("nav.reports") }}
          </p>
        </button>
      }

      <!-- Leader Navigation -->
      @if (currentUserRole() === UserRole.leader) {
        @let isAdminHome = adminRoute === "home";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminHome,
            'bg-transparent': !isAdminHome,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/leader/home'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminHome,
              'text-neutral-600': !isAdminHome,
            }"
            class="pi pi-home"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminHome,
              'text-neutral-600': !isAdminHome,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.home") }}
          </p>
        </button>

        @let isAdminProjects = adminRoute === "projects";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminProjects,
            'bg-transparent': !isAdminProjects,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/leader/projects'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminProjects,
              'text-neutral-600': !isAdminProjects,
            }"
            class="pi pi-briefcase"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminProjects,
              'text-neutral-600': !isAdminProjects,
            }"
            class="text-xs font-semibold"
          >
            {{ t("nav.projects") }}
          </p>
        </button>

        @let isAdminReports = adminRoute === "report";
        <button
          [ngClass]="{
            'bg-[#004E70]': isAdminReports,
            'bg-transparent': !isAdminReports,
          }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="'/leader/report'"
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isAdminReports,
              'text-neutral-600': !isAdminReports,
            }"
            class="pi pi-chart-bar"
          ></i>
          <p
            [ngClass]="{
              'text-white': isAdminReports,
              'text-neutral-600': !isAdminReports,
            }"
            class="text-xs font-semibold whitespace-nowrap"
          >
            {{ t("nav.reports") }}
          </p>
        </button>
      }

      <!-- Teacher / Director Navigation -->
      @if (
        currentUserRole() === UserRole.teacher ||
        currentUserRole() === UserRole.director
      ) {
        <button
          [ngClass]="{ 'bg-[#004E70]': isHome, 'bg-transparent': !isHome }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="
            currentUserRole() === UserRole.teacher
              ? '/teacher/dashboard'
              : '/director/dashboard'
          "
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isHome,
              'text-neutral-600': !isHome,
            }"
            class="pi pi-home"
          ></i>
          <p
            [ngClass]="{ 'text-white': isHome, 'text-neutral-600': !isHome }"
            class="text-xs font-semibold"
          >
            {{ t("nav.home") }}
          </p>
        </button>
        <div class="w-min h-[40px] border-l border-brand-primary"></div>

        <button
          [ngClass]="{ 'bg-[#004E70]': isForm, 'bg-transparent': !isForm }"
          class="w-min h-[32px] py-1 px-2 flex items-center justify-center rounded gap-2"
          [routerLink]="
            currentUserRole() === UserRole.teacher
              ? '/teacher/forms'
              : '/director/forms'
          "
        >
          <i
            [ngClass]="{
              'text-[#1E9ADD]': isForm,
              'text-neutral-600': !isForm,
            }"
            class="pi pi-file"
          ></i>
          <p
            [ngClass]="{ 'text-white': isForm, 'text-neutral-600': !isForm }"
            class="text-xs font-semibold"
          >
            {{ t("nav.forms") }}
          </p>
        </button>
        <div class="w-min h-[40px] border-l border-brand-primary"></div>
        <i class="pi pi-bell text-brand-primary font-bold text-xl"></i>
      }

      <!-- User Actions (Desktop) -->
      @if (
        currentUserRole() == UserRole.admin ||
        currentUserRole() == UserRole.leader ||
        currentUserRole() == UserRole.teacher ||
        currentUserRole() == UserRole.director
      ) {
        <p-avatar
          class="h-12 flex items-center cursor-pointer"
          image="https://primefaces.org/cdn/primeng/images/demo/avatar/onyamalimba.png"
          shape="circle"
          (click)="menu.toggle($event)"
          onkeypress=""
        ></p-avatar>
        <app-language-selector />
      }
    </div>
  </div>
</div>

<div class="xl:hidden">
  <p-menu
    #menu1
    [model]="itemsOptions"
    [popup]="true"
    class="custom-menu-more-options"
  ></p-menu>

  <div
    class="w-full flex flex-row justify-between items-center px-[22px] py-4 fixed top-0 left-0 right-0 z-50 bg-white"
  >
    <div class="flex flex-row items-center gap-2">
      <lib-global-button
        [type]="'default'"
        [icon]="'pi pi-bars '"
        (click)="sidebarVisible = true"
        onKeyPress=""
      />
      <img
        [src]="getLogoPath()"
        [alt]="t('nav.images.logo')"
        class="w-[160px] h-[33px]"
      />
    </div>

    <p-menu #menu2 [popup]="true" [model]="options" appendTo="body"></p-menu>

    <div class="flex flex-row items-center gap-2">
      <p-avatar
        class="h-12 flex items-center"
        image="https://primefaces.org/cdn/primeng/images/demo/avatar/onyamalimba.png"
        shape="circle"
        size="large"
        (click)="menu2.toggle($event)"
        onkeypress=""
      />
    </div>
  </div>

  <p-drawer [(visible)]="sidebarVisible">
    <ng-template pTemplate="header">
      <img
        [src]="getLogoPath()"
        [alt]="t('nav.images.logo')"
        class="w-[221px] h-[33px]"
      />
    </ng-template>
    <ng-template pTemplate="content">
      <div class="flex flex-col gap-[14px] mt-7">
        @if (currentUserRole() === UserRole.admin) {
          <lib-menu-item [text]="t('nav.home')" [routerRedirect]="'/admin/home'" />
          <lib-menu-item [text]="t('nav.templates')" [routerRedirect]="'/admin/templates'" />
          <lib-menu-item [text]="t('nav.institutions')" [routerRedirect]="'/admin/institutions'" />
          <lib-menu-item [text]="t('nav.users')" [routerRedirect]="'/admin/users'" />
          <lib-menu-item [text]="t('nav.projects')" [routerRedirect]="'/admin/projects'" />
          <lib-menu-item [text]="t('nav.reports')" [routerRedirect]="'/admin/report'" />
        }
        @if (currentUserRole() === UserRole.leader) {
          <lib-menu-item [text]="t('nav.home')" [routerRedirect]="'/leader/home'" />
          <lib-menu-item [text]="t('nav.projects')" [routerRedirect]="'/leader/projects'" />
          <lib-menu-item [text]="t('nav.reports')" [routerRedirect]="'/leader/report'" />
        }
        @if (currentUserRole() === UserRole.teacher) {
          <lib-menu-item [text]="t('nav.home')" [routerRedirect]="'/teacher/dashboard'" />
          <lib-menu-item [text]="t('nav.forms')" [routerRedirect]="'/teacher/forms'" />
        }
        @if (currentUserRole() === UserRole.director) {
          <lib-menu-item [text]="t('nav.home')" [routerRedirect]="'/director/dashboard'" />
          <lib-menu-item [text]="t('nav.forms')" [routerRedirect]="'/director/forms'" />
        }
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex flex-col items-center gap-4">
        <app-language-selector />
        <img
          src="./../../../../assets/images/brand/bid-logo.svg"
          [alt]="t('nav.images.bidLogo')"
        />
      </div>
    </ng-template>
  </p-drawer>
</div>

<p-menu #menu [popup]="true" [model]="options" appendTo="body"></p-menu>
<p-popover #op (onHide)="onHide()">
  <app-overlay-notifications />
</p-popover>
